import { Dialog, DialogContent } from '@mui/material';

export const ImageViewDialog = ({ itemIndex, setItemIndex, dataList }) => {
  return (
    <Dialog
      open={itemIndex != null}
      onClose={() => setItemIndex(null)}
      fullWidth
      PaperProps={{
        sx: {
          height: 'calc(100% - 180px)',
          backgroundColor: 'transparent',
          padding: 0,
          '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          },
        },
      }}
    >
      <DialogContent sx={{ padding: 0, overflowY: 'clip' }}>
        <img src={dataList[itemIndex]?.src} alt="data-list" />
      </DialogContent>
    </Dialog>
  );
};
